// extracted by mini-css-extract-plugin
export default {"container":"wgwnfg5w"};